import { Provider } from './../../model/index';
/*import {
    dns
  } from '../../../../providers/global.config';*/
  import {
    NavParams
  } from 'ionic-angular';
  import {
    Component
  } from '@angular/core';
  import {
    Fueling,
    FuelingInfo,
    Type,
    DateInterval
  } from '../../model/index';
  import {
    FuelingService
  } from '../../../../providers/fueling.service';
  import {Subscription} from 'rxjs/Subscription';
  import {Observable} from 'rxjs/Rx';
  import {FileUploader} from 'ng2-file-upload';
  import { AlertController } from 'ionic-angular/components/alert/alert-controller';
import { ViewController } from 'ionic-angular/navigation/view-controller';
  
@Component({
    templateUrl: 'carburant-form.html',
  })

  export class CarburantForm {
   showupdate:boolean=true;   
   fuel:any;
   operationTime:any;
   fuelProviders:any;
   paymentTypes:any;
   idProvider = 0;
   idType = 0;
   providerName: string = null;
   typeName: string = null;
   showprovider:boolean=true;
   provid:any;
   showtype:boolean=true;
   type:any;

    constructor(public viewCtrl:ViewController,public navParams:NavParams,private fuelingService:FuelingService,public alertCtrl:AlertController){
      
      this.fuel=navParams.get('fuel');
        if(this.fuel.cost!=0)this.showupdate=false;
        if(this.fuel.operationTime){
        this.operationTime=(new Date(this.fuel.operationTime)).toISOString();
        } else this.operationTime=(new Date()).toISOString();
       
       }
    ngOnInit(){
      this.fuel.cost=this.precisionRound(this.fuel.cost,2);
    this.fuelingService.getProviders("FUEL").subscribe(response => {
      this.fuelProviders = response;
  
    });
      this.fuelingService.getListType('PAYMENT').subscribe(response => {
        this.paymentTypes = response;
      
    });
    }
    precisionRound(number: number, precision: number) {
      let factor = Math.pow(10, precision);
      return Math.round(number * factor) / factor;
    }
    autresproviders(value:any){
      if(value=="0"){
      this.showprovider=false;
      this.fuel.idProvider=0;
      this.fuel.providerName="";
      }else{
        this.fuelProviders.forEach(provider => {
          if(provider.id==value){
            this.fuel.providerName=provider.name;
          }
      });
      }
    }
    autrestype(value:any){
      if(value=="0"){
        this.showtype=false;
        this.fuel.type.id=0;
      }else{
        this.paymentTypes.forEach(type => {
            if(type.id==value){
              this.fuel.type.name=type.name;
             
            }
        });
      }
    }
    update(){
      this.fuel.operationTime=new Date(this.operationTime);
    
        if (this.fuel.cost >= 10 && this.fuel.odometre >= 10) {
          let data ={fuel:this.fuel,typeName:this.fuel.type.name,idType:this.fuel.type.id,providerName:this.fuel.providerName,idProvider:this.fuel.idProvider}
          this.viewCtrl.dismiss(data);
        }
    
    }
    closeModal(){
        this.viewCtrl.dismiss(null);
    }
      add(){
      this.fuel.operationTime=new Date(this.operationTime);
    
   
        if (this.fuel.cost >= 10 && this.fuel.odometre >= 10) {
          let data ={fuel:this.fuel,typeName:this.fuel.type.name,idType:this.fuel.type.id,providerName:this.fuel.providerName,idProvider:this.fuel.idProvider}
          this.viewCtrl.dismiss(data);
        }
     
    }
    onChange(){
      if(this.fuel.costUnit >0 && this.fuel.quantity>0)
          this.fuel.cost = this.fuel.costUnit*this.fuel.quantity;
      }
  }



// WEBPACK FOOTER //
// ./src/pages/gestion-park/carburant/carburant-form/carburant-form.ts